import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormBuilder} from '@angular/forms';
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: 'update-dialog',
  templateUrl: './update-dialog.component.html',
  styleUrls: ['./update-dialog.component.less']
})
export class UpdateDialogComponent implements OnInit {

  isLoading: boolean = false;
  items: { [id: string]: any[]; } = {};
  // cycleStates: string[] = [];
  customState: string;

  paring: any = {
    name: 'Select all',
    completed: false,
    color: 'primary',
    subtasks: [
      // {name: 'Primary', completed: false, color: 'primary'},
      // {name: 'Accent', completed: false, color: 'accent'},
      // {name: 'Warn', completed: false, color: 'warn'},
    ],
  };

  paringDry: any = {
    name: 'Select all',
    completed: true,
    color: 'primary',
    subtasks: [],
  };

  allowdDryingZones: string[] = []
  allowdZones: string[] = []
  allowdStates: any = []
  cycleStates: string[] = [ 'Mothers', 'Rooting', 'Vegetative', 'Flowering', 'Drying', 'Curing', 'Packing', 'Safe', 'End'];
  zoneRole:  string[] =  ['Mothers', 'Clones', 'Grow', 'Dry', 'Cure', 'Pack', 'Safe', 'General']

  selectAll: boolean = false;
  selectAllDry: boolean = true;

  harvestAndDryWeight: boolean = false
  
  harvest: boolean = false
  disabledHarvest: boolean = true
  disabledUpdateHarvest: boolean = true

  DryWeight: boolean = false
  disabledDryWeight: boolean = true
  disabledUpdateDryWeight: boolean = true

  disabledPlantsQuantity: boolean = false
  disabledHarvestQuantity: boolean = false
  disabledPlantsToHarvest: boolean = true



  constructor(public dialogRef: MatDialogRef<UpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _api: ApiService,) {
      // this.cycleStates = [
      //   'Start', 'Mothers', 'Rooting', 'Vegetative', 'Flowering', 'Flushing', 'Drying', 'Curing', 'Packing', 'Safe', 'Other'
      // ]
      if (this.data.type === 'cycle' && this.data.name.currentState) {
        if (this.cycleStates.findIndex(value => value === this.data.name.currentState.state) === -1) {
          this.customState = this.data.name.currentState.state;
          this.data.name.currentState.state = 'Custom';
        }
      }
      if(this.data.type === 'user' && this.data.data.notificationsPlatforms){
        data.data.notificationsEnabledEmail = this.data.data.notificationsPlatforms.email ? true : false
        data.data.notificationsEnabledSms = this.data.data.notificationsPlatforms.sms ? true : false
        data.data.notificationsEnabledPush = this.data.data.notificationsPlatforms.push ? true : false
      }
  }

  ngOnInit(): void {
    if(this.data.type !== 'user' && this.data.type !== 'company'){
      this.fetchData()
    }
    if(this.data.type === 'sensor'){
      this.sensorData();
      this.zoneData();
    }
    if(this.data.type === 'cycle'){
      this.zoneData()
      this.getParing(this.data.name.currentState.zone);
      // this.getParing(this.data.name.zoneName.id);
      this.disabledHarvest = this.data.name.currentState.state === 'Flowering' ? false : true
      this.harvest = this.data.name.currentState.state === 'Flowering' ? true : false
      this.disabledDryWeight = this.data.name.currentState.state === 'Drying' ? false : true
      this.DryWeight = this.data.name.currentState.state === 'Drying' ? true : false
      if(
        this.data.name.currentState.state === 'Flowering' || 
        this.data.name.currentState.state === 'Drying' ||
        this.data.name.currentState.state === 'Curing' ||
        this.data.name.currentState.state === 'Packing' ||
        this.data.name.currentState.state === 'Safe'
        )
        {
          this.harvestAndDryWeight = true
        }
      const {state} = this.data.name.currentState
      if(state === 'Drying' || state === 'Curing' || state === 'Packing' || state === 'Safe'){
        this.disabledPlantsQuantity = true
        this.disabledHarvestQuantity = true
      }
      if(this.harvest){
        this.data.name.harvest.quantity = 'all'
        this.data.name.harvest.PlantsToHarvest = this.data.name.grow.plantsQuantity - this.data.name.grow.harvestQuantity
      }
    }
  }

  onConfirm() {
    if (this.data.name?.length === 0) {
      return;
    }
    this.isLoading = true;

    if(this.data.type === 'cycle'){
      let sensors = [];
      if(this.paring.subtasks.length){
        this.paring.subtasks.forEach(sensor=>{
          if(sensor.completed){
            sensors.push(sensor.id)
          }
        })
      }
      this.data.name.isAllSensors = (sensors.length === this.paring.subtasks.length) ? true : false
      this.data.name.sensors = sensors
      this.data.data = {...this.data, customState: this.customState}
    }

    if(this.data.type === 'user'){
      let notificationsPlatforms = this.data.data.notificationsEnabled ? {
        email: this.data.data.notificationsEnabledEmail ? true : false,
        sms: this.data.data.notificationsEnabledSms ? true : false,
        push: this.data.data.notificationsEnabledPush?  true : false
      } 
      : {
        email: false,
        sms: false,
        push: false
      }
      this.data.data.notificationsPlatforms = notificationsPlatforms
    
    }
    this.data.function(this.data).subscribe(
      result => {
        this.dialogRef.close(this.data.data);
      }, err => {
        alert(err.message);
        this.isLoading = false;
      }, complete => {
        this.isLoading = false;
      }
    )
  }

  fetchData() {
    let company
    if (localStorage.getItem('currentCompany')) {
      company = JSON.parse(localStorage.getItem('currentCompany'));
     
    }
    this._api.get<any>(`/gateway/company/${company._id}`).subscribe(resp => {
        this.items[this.data.type] = resp.gateways;
    }, err => {
        alert(err.message);
    });

  }

  sensorData(){
    this._api.get<any>('/sensor').subscribe(resp => {
      this.items['sensor'] = resp.sensors.map(s => ({
          ...s,
          average: (s.average || []).join(',')
      }));
      this.items['sensorKinds'] = resp.sensorKinds;
       let actionTypes = resp.actionTypes;
  }, err => {
      alert(err.message);
  });
  }

  zoneData(){
    let company
    if (localStorage.getItem('currentCompany')) {
      company = JSON.parse(localStorage.getItem('currentCompany'));
     
    }
    this._api.get<any>(`/zone/company/${company._id}?slim=true`).subscribe(resp => {
      this.items['zone'] = resp;
      this.allowdZones = resp
      if(this.data.type === 'cycle'){
        this.setCurrentState();
        this. fillterAlowd('zone')
      }
      if(this.data.type === 'cycle' && this.data.name.currentState.state === 'Flowering'){
        this.allowdDryingZones = resp.filter(zone => {
          return zone.role === 'Dry' || zone.role === 'General'
        })
      }
    }, err => {
        alert(err.message);
    });
  }

  getParing(zoneId){
    this.paring.subtasks = []
    this._api.get<any>(`/sensor/sensors/${zoneId}`).subscribe(resp => {
      resp.sensors.forEach(sensor => {
        let isInclude = this.data.name.currentState.sensors.includes(sensor.id);
        this.paring.subtasks.push({name: sensor.name, id:sensor.id,  completed: isInclude, color: 'primary', kind: sensor.kind})
      });
  }, err => {
      alert(err.message);
  });
  }

  updateAllComplete() {
    this.selectAll = this.paring.subtasks != null && this.paring.subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.paring.subtasks == null) {
      return false;
    }
    return this.paring.subtasks.filter(t => t.completed).length > 0 && !this.selectAll;
  }

  setAll(completed: boolean) {
    this.selectAll = completed;
    if (this.paring.subtasks == null) {
      return;
    }
    this.paring.subtasks.forEach(t => (t.completed = completed));
  }

  setAllDry(completed: boolean) {
    this.selectAllDry = completed;
    if (this.paringDry.subtasks == null) {
      return;
    }
    this.paringDry.subtasks.forEach(t => (t.completed = completed));
  }

  disabledUpdateHarvestButton(zoneId){
    if(zoneId){
      this.paringDry.subtasks = []
      this._api.get<any>(`/sensor/sensors/${zoneId}`).subscribe(resp => {
        resp.sensors.forEach(sensor => {
          this.paringDry.subtasks.push({name: sensor.name, id:sensor.id,  completed: true, color: 'primary', kind: sensor.kind})
        });
      }, err => {
          alert(err.message);
      });
    }
    
    const {dryingZone, harvest} = this.data.name
    this.disabledUpdateHarvest = dryingZone && ((harvest.PlantsToHarvest || harvest.quantity) || harvest.updateWetWeight) ? false : true
    if(this.data.name.harvest.PlantsToHarvest > (this.data.name.grow.plantsQuantity - this.data.name.grow.harvestQuantity)){
      this.disabledUpdateHarvest = true
    }
  }

  disabledUpdateDryWeightButton(){
    this.disabledUpdateDryWeight = this.data.name.harvest.updateDryWeight && this.data.name.harvest.updateDryWeight > 0 ? false : true
  }

  updateDryWeight(){
    if(!this.disabledUpdateDryWeight){
      let PostHarvestData = {
        harvest : {dryWeight: this.data.name.harvest.updateDryWeight}
      }
      this._api.put<any>(`/zone/${this.data.name.zoneName.id}/cycle/${this.data.name.id}/post-harvest` , PostHarvestData).subscribe(resp => {
        if(resp.updated){
          this.data.name.harvest.dryWeight += this.data.name.harvest.updateDryWeight
          this.data.name.harvest.updateDryWeight = 0
        }
        
      }, err => {
          alert(err.message);
      });
    }else{
      alert('Dry Weight is required')
    }
    
  }

  updateHarvest(){
    if(!this.disabledUpdateHarvest){
      let sensors = [];
      if(this.paringDry.subtasks.length){
        this.paringDry.subtasks.forEach(sensor=>{
          if(sensor.completed){
            sensors.push(sensor.id)
          }
        })
      }
      let updateHarvestData = {
        grow: {
          harvestQuantity : this.data.name.harvest.PlantsToHarvest,
          nextZone: this.data.name.dryingZone,
          nextSensors: sensors
        },
        harvest : {wetWeight: this.data.name.harvest.updateWetWeight}
      }
      this._api.put<any>(`/zone/${this.data.name.zoneName.id}/cycle/${this.data.name.id}/harvest` , updateHarvestData).subscribe(resp => {
        if(resp.updated){
          this.data.name.grow.harvestQuantity += this.data.name.harvest.PlantsToHarvest
          this.data.name.harvest.wetWeight += this.data.name.harvest.updateWetWeight
          if(this.data.name.grow.plantsQuantity === this.data.name.grow.harvestQuantity){
            this.disabledHarvest = true
            this.harvest = false
            this.data.name.currentState.state = 'Drying'
            this.data.name.zoneName._id = this.data.name.dryingZone
            this.setCurrentState()
            this.fillterAlowd('zone')
            this.disabledDryWeight = this.data.name.currentState.state === 'Drying' ? false : true
            this.DryWeight = this.data.name.currentState.state === 'Drying' ? true : false
            this.paring = this.paringDry
          }
          this.data.name.harvest.quantity = 'custom'
          this.data.name.harvest.PlantsToHarvest = 0
          this.data.name.harvest.updateWetWeight = 0
        }
        
      }, err => {
          alert(err.message);
      });
    }else{
      alert('Pick zone is required')
    } 
  }

  setCurrentState(){
    let states = new Set
    let index = this.cycleStates.findIndex(state => this.data.name.currentState.state === state)
      this.items['zone'].forEach( zone => {
        if(zone.role === 'Mothers' && this.cycleStates.findIndex(state => 'Mothers' === state) >= index){
          states.add('Mothers')
        }
        if(zone.role === 'Clones' ){
          if(this.cycleStates.findIndex(state => 'Rooting' === state) >= index){
            states.add('Rooting')
          }
          if(this.cycleStates.findIndex(state => 'Vegetative' === state) >= index){
            states.add('Vegetative')
          } 
        }
        if(zone.role === 'Grow'){
          if(this.cycleStates.findIndex(state => 'Vegetative' === state) >= index){
            states.add('Vegetative')
          }
          if(this.cycleStates.findIndex(state => 'Flowering' === state) >= index){
            states.add('Flowering')
          }
        }
        if(zone.role === 'Dry' && this.cycleStates.findIndex(state => 'Drying' === state) >= index && this.data.name.currentState.state !== 'Flowering'){ 
          states.add('Drying')
        }
        if(zone.role === 'Cure' && this.cycleStates.findIndex(state => 'Curing' === state) >= index && this.data.name.currentState.state !== 'Flowering'){ 
          states.add('Curing')
        }
        if(zone.role === 'Pack' && this.cycleStates.findIndex(state => 'Packing' === state) >= index && this.data.name.currentState.state !== 'Flowering'){ 
          states.add('Packing')
        }
        if(zone.role === 'Safe' && this.cycleStates.findIndex(state => 'Safe' === state) >= index && this.data.name.currentState.state !== 'Flowering'){ 
          states.add('Safe')
        }
        states.add('End')
      })
      let statesArray = Array.from(states)
      this.allowdStates = this.cycleStates.filter( state => state === statesArray.find(allwoedState => allwoedState === state))
  }

  fillterAlowd(type: string){
    if(type === 'zone'){
      let index = this.cycleStates.findIndex(state => this.data.name.currentState.state === state)
      this.allowdZones = this.items['zone'].filter(zone => {
        if(this.data.name.currentState.state === 'Mothers' && this.cycleStates.findIndex(state => 'Mothers' === state) >= index){
          return (zone.role === 'Mothers') 
        }
        if(this.data.name.currentState.state === 'Rooting'){
          return (zone.role === 'Clones' || zone.role === 'General')
        }
        if(this.data.name.currentState.state === 'Vegetative'){
          return (zone.role === 'Clones' || zone.role === 'Grow' || zone.role === 'General')
        }
        if(this.data.name.currentState.state === 'Flowering'){
          return (zone.role === 'Grow' || zone.role === 'General')
        }
        if(this.data.name.currentState.state === 'Drying'){
          return (zone.role === 'Dry'  || zone.role === 'General')
        }
        if(this.data.name.currentState.state === 'Curing'){
          return (zone.role === 'Cure' || zone.role === 'General')
        }
        if(this.data.name.currentState.state === 'Packing'){
          return (zone.role === 'Pack' || zone.role === 'General')
        }
        if(this.data.name.currentState.state === 'Safe'){
          return (zone.role === 'Safe' || zone.role === 'General')
        }
      })
    }
  }

  customPlants(type: string){
    this.disabledPlantsToHarvest = type === 'custom' ? false : true
    if(type === 'all'){
      this.data.name.harvest.PlantsToHarvest = this.data.name.grow.plantsQuantity - this.data.name.grow.harvestQuantity
    }
    if(type === 'half'){
      this.data.name.harvest.PlantsToHarvest = (this.data.name.grow.plantsQuantity - this.data.name.grow.harvestQuantity)/2
      this.data.name.harvest.PlantsToHarvest = Math.floor(this.data.name.harvest.PlantsToHarvest)
    }
  }

}
